import React from 'react';
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import { Divider, Link, Typography } from '../../ecosystem';

const AppointmentTileHeading = ({
    disabled = false,
    patientName,
    to,
    tooltip,
    visitName,
}) => {

    return (
        <div className="col-12 appt-tile-heading">
            <div className="row">
                <div className="col-12 col-xl-6 appt-tile-heading__visit">
                    <div className="appt-tile-heading__visit-name">
                        <Link
                            to={to}
                            onClick={() => logUI("MBHWeb.Dashboard.AppointmentTile.AppointmentDetails.Click", new Date(), Tools.getURLPath())}
                            disabled={disabled}
                            typographyType="heading-01"
                        >
                            {visitName}
                        </Link>
                    </div>
                    
                    {tooltip &&
                        <div className="appt-tile-heading__tooltip">
                            {tooltip}
                        </div>
                    }
                </div>
                <div className="col-12 col-xl-6 appt-tile-heading__patient">
                    <Typography
                        type="body-01"
                        bold
                        color={disabled ? "$color-secondary-a3" : "$color-primary-a2"}
                        tag="div"
                    >
                        {patientName}
                    </Typography>
                </div>
            </div>
            <div className="appt-tile-divider">
                <Divider
                    mTop="small"
                    mBottom="small"
                    mRight="none"
                    mLeft="none"
                    orientation="horizontal"
                />
            </div>
        </div>
    );
}

export default AppointmentTileHeading;